import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { determineStateData, isStateRequiredCountry } from 'commons/utils'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const State = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const country = useWatch({ control, name: `institutionActivitiesInfo.${index as 0}.country` })
  const state = useWatch({ control, name: `institutionActivitiesInfo.${index as 0}.state` })
  const states = determineStateData(country)

  // disable input if it has one option and it's selected
  const isDisabled = states.length === 1 && state === states[0].value

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.state`}
      control={control}
      rules={{
        validate: (value) =>
          !isStateRequiredCountry(country) || !!value
            ? undefined
            : '"63. State" required when choose "United States of America" as "65. Country"'
      }}
      render={({ field }) => (
        <FF2
          required={isStateRequiredCountry(country)}
          label="63. State"
          field={field}
          input={(props) => (
            <Select
              {...props}
              searchable
              disabled={isDisabled}
              data={states}
              data-qa="63. State"
              options-data-qa="63. State option"
            />
          )}
        />
      )}
    />
  )
}
